import(/* webpackMode: "eager" */ "/Users/stephenayala/Downloads/Programming/DebraMikus/simpler-horizons/app/error.tsx")